import styled from "styled-components";

export const TextFieldContainer = styled.div`
    margin-left: 100px;
    margin-right: 110px;
`;
